import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { NotificationManager } from "react-notifications";

import SelectCategoryForm from "./selectCategoryForm";
import PaginatedTable from "../../../../sharedComponents/tableWithPagination";
import FilterPanel, { PanelBody } from "../../../../sharedComponents/filterPanel";
import { removeRecipeCategory, addRecipeCategories, getRecipeDetails } from "../../../../store/actions";
import ConfirmDelete from "../../../../sharedComponents/confirmDelete";

const Categories = ({
	recipeDetails,
	setActiveTab,
	removeRecipeCategory,
	addRecipeCategories,
	getRecipeDetails,
	newAdditions
}) => {
	const [recipeCategories, updateRecipeCategories] = useState([]);
	const [submitting, setSubmitting] = useState(false);

	useEffect(() => {
		newAdditions("categories", recipeCategories.filter((item) => item.isNew).length > 0);
	}, [recipeCategories, newAdditions]);

	useEffect(() => {
		recipeDetails && recipeDetails.categories && updateRecipeCategories(recipeDetails.categories);
	}, [recipeDetails]);

	const addToRecipeCategories = (event) => {
		const newCategory = {
			category__group__name: event.groupName,
			category__id: event.id,
			category__name: event.itemName,
			isNew: true
		};
		updateRecipeCategories([...recipeCategories, newCategory]);
	};

	const removeCategory = (original) => {
		const successHandler = () => {
			updateRecipeCategories(recipeCategories.filter((item) => item.category__id !== original.category__id));
		};
		if (!original.isNew) {
			removeRecipeCategory(original.id, successHandler);
		} else {
			successHandler();
		}
	};

	const columns = [
		{
			Header: "Category Group",
			accessor: "category__group__name",
			width: 300
		},
		{
			Header: "Category",
			accessor: "category__name"
		},
		{
			Header: "Actions",
			accessor: "category__id",
			className: "text-right",
			headerClassName: "text-right",
			width: 100,
			Cell: ({ original }) => (
				<button
					type="button"
					onClick={() => confirmDelete(original)}
					className="btn btn-danger  btn-ghost btn-sm btn-cell">
					<i className="icon icon-trash" />
				</button>
			),
			sortable: false
		}
	];

	const [showAddCategoryPanel, toggleAddCategoryPanel] = useState(false);

	const submitRecipeCategories = () => {
		const newCategories = recipeCategories.filter((item) => item.isNew);
		const listItems = newCategories.map((item) => ({
			recipe: recipeDetails.id,
			category: item.category__id
		}));
		const successHandler = (event) => {
			getRecipeDetails(recipeDetails.id);
			setSubmitting(false);
			if (event.status === 201) {
				NotificationManager.success("Successfully added!", "", 5000);
				setActiveTab(3);
			} else {
				NotificationManager.error("Please try again!", "", 5000);
			}
		};
		if (listItems.length) {
			setSubmitting(true);
			addRecipeCategories(listItems, successHandler);
		} else {
			setActiveTab(3);
		}
	};

	const [deleteItem, setDeleteItem] = useState(null);
	const confirmDelete = (original) => {
		setDeleteItem(original);
	};
	const confirmEvent = (yes) => {
		yes && removeCategory(deleteItem);
		setDeleteItem(null);
	};

	return recipeDetails && recipeDetails.id ? (
		<React.Fragment>
			<div className="p-4">
				<div className="row">
					<div className="col-12">
						<div className="d-flex align-items-center">
							<h4 className="flex-fill m-0">Category Listing</h4>
							<button
								type="button"
								onClick={() => toggleAddCategoryPanel(true)}
								className="btn btn-primary text-uppercase">
								<i className="icon icon-plus" /> Add new
							</button>
						</div>
						<div className="table-container">
							{recipeCategories && recipeCategories.length ? (
								<PaginatedTable data={recipeCategories} columns={columns} />
							) : (
								<div className="alert alert-info text-center mt-3">No category selected!</div>
							)}
						</div>
					</div>
				</div>
				<div className="tab-footer row pt-3">
					<div className="col-12 text-right">
						<button type="button" className="btn btn-default" onClick={() => setActiveTab(1)}>
							Back
						</button>
						<button
							type="button"
							className="btn btn-primary-dark"
							onClick={submitRecipeCategories}
							disabled={!recipeCategories.length || submitting}>
							Save &amp; Next
						</button>
					</div>
				</div>
			</div>
			<ConfirmDelete item={deleteItem} message={<div>Are you sure you want to delete?</div>} onEvent={confirmEvent} />
			<FilterPanel
				className="add-category-panel"
				show={showAddCategoryPanel}
				toggle={() => toggleAddCategoryPanel(!showAddCategoryPanel)}
				title="Add Category"
				closeBtn>
				<PanelBody className="d-flex flex-column">
					<SelectCategoryForm
						recipeCategoryList={recipeCategories}
						onUpdate={addToRecipeCategories}
						togglePanel={(event) => toggleAddCategoryPanel(event)}
					/>
				</PanelBody>
			</FilterPanel>
		</React.Fragment>
	) : null;
};

const mapStateToProps = (state) => {
	return {
		recipeDetails: get(state, "Recipes.recipeDetails", [])
	};
};

const mapDispatchToProps = {
	removeRecipeCategory,
	addRecipeCategories,
	getRecipeDetails
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Categories);
